































































































































































import { Component, Vue } from "vue-property-decorator";
import { EnrollmentOrder as IEnrollmentOrder } from "@/api/models/enrollment-order";
import api from "@/getinfo-api";
import { Employee as IEmployee } from "@/api/models/employee";
import EnrollmentOrderFormItemUsers from "@/components/enrollment/EnrollmentOrderFormItemUsers.vue";
import { EnrollmentOrderEdit as IEnrollmentOrderEdit } from "@/api/models/enrollment-order-edit";
import { isRoot } from "@/plugins/roles";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import DocumentArchiveButton from "@/components/form/DocumentArchiveButton.vue";
import { generatePdf } from "@/utils/files-helper";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";

@Component({
  components: {
    DocTemplateGenerateV2,
    DocumentArchiveButton,
    EntityFiles,
    TextField,
    CBlock,
    CBreadCrumbs,
    EnrollmentOrderFormItemUsers
  }
})
export default class EnrollmentOrderView extends Vue {
  enrollment!: IEnrollmentOrder;
  responsible!: IEmployee;
  showSpinner: boolean = false;
  sortVariable: string = "";
  isLoadingFiles: boolean = false;

  data() {
    return {
      enrollment: undefined,
      responsible: undefined
    };
  }

  async _generatePdf(file: any) {
    this.isLoadingFiles = true;
    const response = await generatePdf(file)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
    this.addFiles([response.id], true);
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    let params: IEnrollmentOrderEdit = {
      fileIds:
        this.enrollment.files && fromDocTemplate
          ? [...this.enrollment.files.map((el: any) => el.id), ...files]
          : [...files],
      number: this.enrollment.number,
      ownerId: this.enrollment.ownerId,
      listeners: this.enrollment.listeners.map((el: any) => el.id),
      formedAt: this.enrollment.formedAt,
      courseId: this.enrollment.courseId,
      signedAt: this.enrollment.signedAt,
      educationStartedAt: this.enrollment.educationStartedAt,
      educationFinishedAt: this.enrollment.educationFinishedAt
    };

    this.isLoadingFiles = true;

    api.EnrollmentOrderApi.edit(this.enrollment.id, params)
      .then((res: { data: IEnrollmentOrder }) => {
        this.enrollment = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "enrollmentList" },
        label: this.$tc(this.$translate.OrdersOfEnrollment)
      },
      {
        label: this.enrollment.number
      }
    ];
  }

  get status() {
    return !!this.enrollment?.signedAt;
  }

  get isRoot() {
    return isRoot();
  }

  get courseLink() {
    const v1 = { name: "courseView", params: { courseId: this.course?.id } };
    const v2 = { name: "course", params: { id: this.course?.id } };

    return this.courseVersion === "v1" ? v1 : v2;
  }

  get courseVersion() {
    return this.course.version;
  }

  get course() {
    return this.enrollment?.listeners?.[0]?.course;
  }

  sortListeners(sortItem: string) {
    this.sortVariable = sortItem;
    if (sortItem === "Тест") {
      this.enrollment.listeners.sort((x, y) => {
        return x.testCompleted === y.testCompleted
          ? 0
          : x.testCompleted
          ? -1
          : 1;
      });
    } else if (sortItem === "Практика") {
      this.enrollment.listeners.sort((x, y) => {
        return x.practiceCompleted === y.practiceCompleted
          ? 0
          : x.practiceCompleted
          ? -1
          : 1;
      });
    } else if (sortItem === "Обучение") {
      this.enrollment.listeners.sort((x, y) => {
        return x.learningCompleted === y.learningCompleted
          ? 0
          : x.learningCompleted
          ? -1
          : 1;
      });
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }

  async getEnrollment() {
    this.showSpinner = true;
    try {
      let getEnrollmentResponse = await api.EnrollmentOrderApi.get(
        this.$route.params.enrollmentId
      );
      this.enrollment = getEnrollmentResponse.data;

      let getResponsibleResponse = await api.EmployeeApi.get(
        this.enrollment.companyId,
        this.enrollment.ownerId
      );
      this.responsible = getResponsibleResponse.data;
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.showSpinner = false;
    }
  }

  created() {
    this.getEnrollment();
  }
}
